/* Magno Botanics – Datos para factura en el carrito (se guardan como atributos del pedido) */
(function () {
  'use strict';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEYS = {
    doc: 'Documento',
    rut: 'RUT empresa',
    razon: 'Razón social',
    giro: 'Giro',
    dir: 'Dirección de facturación',
    email: 'Email para factura'
  };
  var state = null;   // atributos actuales del carrito
  var timer = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* RUT chileno: módulo 11 */
  function cleanRut(v) { return String(v || '').replace(/[^0-9kK]/g, '').toUpperCase(); }
  function formatRut(v) {
    var c = cleanRut(v);
    if (c.length < 2) return c;
    var body = c.slice(0, -1), dv = c.slice(-1);
    return body.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
  }
  function validRut(v) {
    var c = cleanRut(v);
    if (c.length < 8) return false;
    var body = c.slice(0, -1), dv = c.slice(-1), sum = 0, mul = 2;
    for (var i = body.length - 1; i >= 0; i--) { sum += Number(body[i]) * mul; mul = mul === 7 ? 2 : mul + 1; }
    var r = 11 - (sum % 11);
    var exp = r === 11 ? '0' : r === 10 ? 'K' : String(r);
    return dv === exp;
  }

  function loadState() {
    if (state) return Promise.resolve(state);
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { state = c.attributes || {}; return state; })
      .catch(function () { state = {}; return state; });
  }

  function save(attrs) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {});
    }, 350);
  }

  function field(id, key, label, ph, type, val) {
    return '<label class="mb-fac__field"><span>' + label + '</span>' +
      '<input type="' + (type || 'text') + '" data-fac="' + key + '" placeholder="' + esc(ph) + '" value="' + esc(val) + '" autocomplete="off"></label>';
  }

  function html(a) {
    var on = a[KEYS.doc] === 'Factura';
    return '<div class="mb-fac' + (on ? ' is-open' : '') + '">' +
      '<label class="mb-fac__toggle"><input type="checkbox" data-fac-toggle' + (on ? ' checked' : '') + '>' +
      '<span>Necesito factura</span></label>' +
      '<div class="mb-fac__body">' +
        '<p class="mb-fac__hint">Emitimos factura electrónica. Ingresa los datos de tu empresa y la enviamos a tu correo.</p>' +
        field('rut', KEYS.rut, 'RUT empresa', '76.123.456-7', 'text', a[KEYS.rut]) +
        field('razon', KEYS.razon, 'Razón social', 'Empresa SpA', 'text', a[KEYS.razon]) +
        field('giro', KEYS.giro, 'Giro', 'Ej: Servicios de decoración', 'text', a[KEYS.giro]) +
        field('dir', KEYS.dir, 'Dirección de facturación', 'Calle, número, comuna', 'text', a[KEYS.dir]) +
        field('email', KEYS.email, 'Email para la factura', 'facturas@empresa.cl', 'email', a[KEYS.email]) +
        '<p class="mb-fac__error" hidden></p>' +
      '</div>' +
    '</div>';
  }

  function collect(box) {
    var on = box.querySelector('[data-fac-toggle]').checked;
    var attrs = {};
    attrs[KEYS.doc] = on ? 'Factura' : '';
    box.querySelectorAll('[data-fac]').forEach(function (inp) { attrs[inp.getAttribute('data-fac')] = on ? inp.value.trim() : ''; });
    return attrs;
  }

  function problems(box) {
    if (!box.querySelector('[data-fac-toggle]').checked) return '';
    var get = function (k) { var i = box.querySelector('[data-fac="' + k + '"]'); return i ? i.value.trim() : ''; };
    if (!validRut(get(KEYS.rut))) return 'Revisa el RUT de la empresa.';
    if (!get(KEYS.razon)) return 'Falta la razón social.';
    if (!get(KEYS.giro)) return 'Falta el giro.';
    if (!get(KEYS.dir)) return 'Falta la dirección de facturación.';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(get(KEYS.email))) return 'Revisa el email para la factura.';
    return '';
  }

  function bind(box) {
    box.addEventListener('change', function (e) {
      if (e.target.matches('[data-fac-toggle]')) box.classList.toggle('is-open', e.target.checked);
      if (e.target.matches('[data-fac="' + KEYS.rut + '"]')) e.target.value = formatRut(e.target.value);
      var attrs = collect(box);
      state = Object.assign({}, state || {}, attrs);
      save(attrs);
    });
    box.addEventListener('input', function (e) {
      if (!e.target.matches('[data-fac]')) return;
      var attrs = collect(box);
      state = Object.assign({}, state || {}, attrs);
      save(attrs);
      var err = box.querySelector('.mb-fac__error'); if (err) err.hidden = true;
    });
  }

  function mount() {
    var spots = [];
    var drawer = document.querySelector('cart-drawer');
    var drawerFooter = drawer && drawer.querySelector('.drawer__footer');
    /* En el carrito lateral va antes del pie (zona que se desplaza), así el botón de pago queda siempre visible */
    if (drawerFooter && !drawer.classList.contains('is-empty')) spots.push({ scope: drawer.querySelector('.drawer__inner') || drawer, before: drawerFooter });
    var pageFooter = document.querySelector('#main-cart-footer .cart__blocks, .cart__footer .cart__blocks');
    if (pageFooter) { var a = pageFooter.querySelector('.cart__ctas, .totals'); spots.push({ scope: pageFooter, before: a }); }
    if (!spots.length) return;
    loadState().then(function (a) {
      spots.forEach(function (s) {
        if (s.scope.querySelector('.mb-fac')) return;
        var wrap = document.createElement('div');
        wrap.innerHTML = html(a);
        var box = wrap.firstChild;
        if (s.before && s.before.parentNode) s.before.parentNode.insertBefore(box, s.before);
        else s.scope.insertBefore(box, s.scope.firstChild);
        bind(box);
      });
    });
  }

  /* No dejar pasar al pago si marcó factura y faltan datos */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="checkout"], #CartDrawer-Checkout, #checkout');
    if (!btn) return;
    var box = btn.closest('cart-drawer, #main-cart-footer, body').querySelector('.mb-fac') || document.querySelector('.mb-fac');
    if (!box) return;
    var msg = problems(box);
    if (msg) {
      e.preventDefault(); e.stopPropagation();
      var err = box.querySelector('.mb-fac__error');
      err.textContent = msg; err.hidden = false;
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  function init() {
    mount();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(mount, 150); })
        .observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
